// extracted by mini-css-extract-plugin
export default {"label":"label__um0JI"};